import { idtype } from "querypieces";

export default `
...on pageBuilder_bodyCopy_BlockType {
	${idtype}
	richText
}
`